import { lazy } from 'react';

export const MyNfts = lazy(() => import('./MyNfts.component'));
